// Dropdown меню по клику
document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.menu-item-has-children');

    menuItems.forEach(item => {
        const link = item.querySelector('a');
        const submenu = item.querySelector('.sub-menu');
        const icon = link ? link.querySelector('iconify-icon') : null;

        if (link && submenu) {
            // Клик по ссылке с подменю
            link.addEventListener('click', function(e) {
                e.preventDefault();

                // Закрываем все другие открытые подменю
                menuItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        const otherSubmenu = otherItem.querySelector('.sub-menu');
                        const otherIcon = otherItem.querySelector('a iconify-icon');
                        if (otherSubmenu) {
                            otherSubmenu.classList.add('hidden');
                        }
                        if (otherIcon) {
                            otherIcon.style.transform = 'rotate(0deg)';
                        }
                    }
                });

                // Переключаем текущее подменю
                const isHidden = submenu.classList.toggle('hidden');

                // Поворачиваем стрелку
                if (icon) {
                    icon.style.transform = isHidden ? 'rotate(0deg)' : 'rotate(180deg)';
                    icon.style.transition = 'transform 0.2s';
                }
            });
        }
    });

    // Закрытие при клике вне меню
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.menu-item-has-children')) {
            menuItems.forEach(item => {
                const submenu = item.querySelector('.sub-menu');
                const icon = item.querySelector('a iconify-icon');
                if (submenu) {
                    submenu.classList.add('hidden');
                }
                if (icon) {
                    icon.style.transform = 'rotate(0deg)';
                }
            });
        }
    });
});